"use strict";
/**
 * @license
 * Copyright 2023 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var ChunkKeyEncoding = /* @__PURE__ */ ((ChunkKeyEncoding2) => {
  ChunkKeyEncoding2[ChunkKeyEncoding2["DEFAULT"] = 0] = "DEFAULT";
  ChunkKeyEncoding2[ChunkKeyEncoding2["V2"] = 1] = "V2";
  return ChunkKeyEncoding2;
})(ChunkKeyEncoding || {});
